export const limitNumberOfDays = 14;
export const minDaysInIrregularSchedule = 2;
export const cellDuration = 60;
